import { FC, SVGAttributes } from "react";

import { cn } from "@/lib/utils";

export interface LogoProps extends SVGAttributes<SVGSVGElement> {}

export const Logo: FC<LogoProps> = ({ className, ...props }) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 960 560"
      fill="none"
      className={cn("text-[#019FDD]", className)}
    >
      <g>
        <path
          fill="currentColor"
          d="M674.4,348.8c-4.7,5.2-9.4,9.3-14.9,12.2c-7.1,3.8-14.7,5.4-22.6,4.8c-9.1-0.6-17.2-4.1-23.6-10.7
		c-5.5-5.8-8.6-12.9-9.7-20.8c-2.7-19.5-1-39.2-1.5-58.7c-0.1-3.4,0.1-6.7-0.1-10.1c-0.1-1.7,0.5-2,2.1-2c3.9,0.1,7.9,0.1,11.8,0
		c1.5,0,2,0.3,1.9,1.9c-0.1,4.6,0,9.2,0,13.8c0,14.5-0.1,29,0.1,43.5c0.1,6.1,1.2,12.1,4.1,17.7c3.5,6.7,9.2,10,16.4,10.7
		c6.3,0.6,12.4-0.4,18-3.7c8.9-5.2,14.4-12.9,16.5-22.9c0.9-4.3,0.8-8.7,1.1-13.1c0.9-15.3,0.2-30.6,0.4-45.9c0-1.7,0.5-2.1,2.1-2
		c3.6,0.1,7.2,0.1,10.8,0c1.9-0.1,2.5,0.4,2.4,2.4c-0.1,11.2,0,22.3,0,33.5c0,20.5,0,41,0.1,61.5c0,2.2-0.6,2.7-2.7,2.6
		c-3.6-0.2-7.2-0.1-10.8,0c-1.4,0-1.8-0.3-1.8-1.8C674.4,357.6,674.4,353.6,674.4,348.8z"
        />
        <path
          fill="currentColor"
          d="M819.1,265.4c0-1.6-0.6-1.9-2-1.9c-2.9,0.1-5.9,0-8.9,0c-4.5,0-4.5,0-4.5,4.5c0,3.2,0,6.4,0,10.2
		c-1.4-1.4-2.2-2.3-3.1-3.2c-8.5-9.3-19.3-13.7-31.7-14.3c-6.5-0.4-12.9,0.7-19,2.8c-13.5,4.7-23.4,13.7-29.8,26.3
		c-4.6,9-6.2,18.6-5.1,28.8c0.7,6.4,2.2,12.5,4.8,18.3c3.3,7.2,8.5,13,14.3,18.2c3.5,3.1,7.6,5.6,12,7.5c9.2,4,18.7,4.7,28.5,3.3
		c4.7-0.6,9.1-2.3,13.3-4.5c5.9-3,10.9-7.1,15.8-12.5c0,4.7,0.1,8.7,0,12.7c0,1.4,0.2,2,1.9,2c3.9-0.1,7.7-0.1,11.6,0
		c1.5,0,1.9-0.4,1.9-1.9C819,329.5,819,297.4,819.1,265.4z M804.4,315.3c-0.5,18.7-16.6,37.8-39.5,36.5c-16.8-1-35.4-17.9-34.4-39.8
		c0.8-18.3,16.7-37.1,37-36.1C787.6,275,805,293,804.4,315.3z"
        />
        <path
          fill="currentColor"
          d="M315.4,288.8c-3.8-7.4-9.4-13.4-15.9-18.4c-7.9-6.1-17.1-9.1-27.1-9.3c-3.7-0.1-7.3-0.1-11,0.4
		c-5.3,0.7-10.3,2.4-15.1,4.7c-5.7,2.8-10.4,7-14.8,11.7c-4.7,5-8.1,10.7-10.5,17.1c-2.6,6.9-3.2,14.1-3,21.5c0.2,7,1.8,13.7,4.8,20
		c3.2,6.7,7.7,12.4,13.3,17.3c8.5,7.5,18.5,11.4,29.7,12.1c4.8,0.3,9.5,0,14.3-0.9c14.5-2.8,25.2-10.9,33-23
		c5.6-8.6,8.2-18.1,7.7-28.8C321.5,304.8,319.3,296.6,315.4,288.8z M298.5,335.9c-4.5,6.1-10.2,11-17.6,13.4
		c-11.4,3.6-22.2,2.3-31.9-4.6c-8-5.7-12.8-13.6-14.7-23.3c-0.5-2.4-0.4-4.7-0.5-8c-0.2-8.7,3.1-17,9.3-24.4
		c5.7-6.8,12.8-11.2,21.4-12.4c9.5-1.3,18.4,0.7,26.1,7c7.6,6.2,12.6,14,14.4,23.5C307,317.5,304.9,327.3,298.5,335.9z"
        />
        <path
          fill="currentColor"
          d="M170.6,319.9c2.2-0.9,4.3-1.9,6.4-3.1c6.7-3.7,11.4-9.1,13.8-16.4c1.5-4.7,1.9-9.5,1.3-14.5
		c-0.6-5.1-2.2-9.6-5.6-13.5c-6.6-7.4-15.1-10.2-24.6-10.4c-11.3-0.2-22.6,0-34-0.1c-2.2,0-2.8,0.5-2.8,2.8
		c0.1,32.3,0.1,64.6,0.1,96.9c0,0.4,0,0.8,0,1.2c-0.2,1.2,0.4,1.5,1.5,1.5c3.6-0.1,7.2-0.1,10.8,0c1.9,0.1,2.5-0.4,2.4-2.4
		c-0.1-11.9,0-23.8-0.1-35.7c0-2,0.6-2.4,2.5-2.4c4,0.1,8,0,12.1,0c0.8,0,1.6-0.1,2.2,0.7c4.3,5.7,9,11,13.5,16.5
		c5.8,6.9,11.4,14,17.1,21c0.7,0.9,1.4,2.2,2.8,2.2c6,0,12,0,18.3,0C195.5,349.4,183.1,334.7,170.6,319.9z M161.6,310.7
		c-6.5,1-13.1,1.1-19.7,1.1c-1.6,0-2-0.5-2-2.1c0.1-5.6,0-11.2,0-16.7s0-11.2,0-16.7c0-1.4,0.3-2,1.9-2c6.1,0.1,12.1-0.2,18.2,0.1
		c5,0.3,9.9,1.6,13.4,5.6c2.1,2.4,3.5,5.2,3.5,8.5c0,3.6,0.2,7.1-1.1,10.6C173.3,305.9,168.4,309.7,161.6,310.7z"
        />
      </g>
      <path
        fill="currentColor"
        d="M582.5,380.8c-3.4-3.5-88.3-99.2-91.5-102.9c-3.3-3.1-0.6-1.3-8.4-4.5c-11.5-5-30-12.1-30-12.1
	c0.9,3.1,6.3,23.5,8.2,31.1c1.6,7.1,0.5,5,3.5,8.9c4,5.1,89.3,101.7,89.2,101.9c0.6,0.7,1.1,1.4,1.6,2.2c2.7,4.4,10.2,4.9,13.1,1.4
	c3-3.6,6.8-6.3,10.3-9.4c2-1.7,4.2-3.2,5.9-5.2C586.3,389.8,586.2,384.6,582.5,380.8z M485.3,283c-4.8,4.2-11.2,9.7-16.4,13.7
	c-1.5,1.2-1.9-0.2-2.3-1.3c-0.8-2-7.2-22-10.1-29.8c0,0,29.2,14.4,29.6,14.7C487.2,280.9,487.3,281.3,485.3,283z"
      />
      <g id="Layer_2_copy">
        <path
          fill="currentColor"
          d="M450.2,146c-66.3,0-120,51.5-120,115s53.7,115,120,115s120-51.5,120-115S516.5,146,450.2,146z M450.2,346
		c-48,0-87-38.1-87-85s39-85,87-85s87,38.1,87,85S498.3,346,450.2,346z"
        />
      </g>
    </svg>
  );
};
